// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconAdjustmentsHorizontal, IconFileAnalytics, IconChartHistogram } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconAdjustmentsHorizontal,
    IconFileAnalytics,
    IconChartHistogram
};
const organization: NavItemType = {
  id: 'organizationSection',
  title: <FormattedMessage id="Organization" />,
  type: 'group',
  children: [
        {
            id: 'reports',
            title: <FormattedMessage id="Route Reports" />,
            type: 'item',
            url: '/report/route',
            target: false,
            icon: icons.IconFileAnalytics
        },
        {
            id: 'tax-deduction-reports',
            title: <FormattedMessage id="Tax Deduction Reports" />,
            type: 'item',
            url: '/report/tax-deduction',
            target: false,
            icon: icons.IconFileAnalytics
        },
        {
            id: 'metrics',
            title: <FormattedMessage id="Metrics" />,
            type: 'item',
            url: '/metrics',
            target: false,
            icon: icons.IconChartHistogram
        }
    ]
};

export default organization
